/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
} from 'react-admin'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import BackButton from '../../components/BackButton'
import '../style.css'
import Title from '../../components/Title/Title'
import CustomValidater from '../../components/Utility/Validater'

const DepartmentComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const { isEdit, title, editPress, record } = props
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }
    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...{ ...props, record: { ...record, ...userData } }}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Code"
                    source="code"
                    validate={[required()]}
                    disabled={isEdit}
                />
            </div>
            <div className="container">
                <TextInput
                    onChange={() => {
                        if (isEdit) editPress(true)
                    }}
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Description"
                    source="description"
                    validate={required()}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Created By"
                    source="created_by"
                    validate={required()}
                />
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Modified By"
                    source="modified_by"
                    validate={required()}
                />
            </div>
        </SimpleForm>
    )
}

export default function CreateDepartment(props) {
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const { isEdit } = props
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/PY_DepartmentTAB')
        refresh()
    }
    if (isEdit)
        return (
            <>
                <BackButton path="/PY_DepartmentTAB" />
                <Edit {...props} undoable={false}>
                    <DepartmentComponent title="Edit Department" isEdit />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_DepartmentTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <DepartmentComponent title="Create Department" isEdit={false} />
            </Create>
        </>
    )
}

CreateDepartment.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

DepartmentComponent.defaultProps = {
    editPress: () => {},
}

DepartmentComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    editPress: PropTypes.func,
    record: PropTypes.objectOf(PropTypes.any).isRequired,
}
